module.exports = __webpack_public_path__ + "static/img/portico-favicon.305c8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portico-favicon.png
// module id = Z+kq
// module chunks = 1